import React, { useState, useEffect } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  AddIconBlue,
  AddIconGray,
  EditIconDarkGray,
  EditIconGray,
  ImageWithLocationIcon,
  TrashIconGray,
} from "../../../../constant/imagePath";
import { Row, Col } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./AddressMobile.module.css";
import Map from "../../../CustomMap/CustomMap";
import { Input } from "../../../../stories/Input/Input";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import AddLocationModal from "../../../Modals/CoachFlow/OnBoarding/AddLocation/AddLocation";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";
import LocationInput from "../../../../stories/LocationInput/LocationInput";
import Maps from "../../../Maps";

export default function AddressMobile({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer.address
  );
  const [venueName, setVenueName] = useState();
  const [address, setAddress] = useState();
  const [openAddLocation, setOpenAddLocation] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [coordinate, setCoordinate] = useState({});
  const [locationDetail, setLocationDetail] = useState({});

  const [locations, setLocations] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );

  // Add Location For Modal
  function addLocationForModal(data) {
    const newArr = locations?.slice();
    newArr.push(data);
    setLocations(newArr);
  }

  // Edit Location
  function editLocation(data) {
    const newArr = [...locations];
    const index = newArr?.findIndex((item) => item?._id == data?._id);
    newArr[index] = data;
    setLocations(newArr);
  }

  // Delete Location
  function deleteLocation(e) {
    const newArr = [...locations];
    const index = newArr?.findIndex((item) => item?._id === e._id);
    newArr.splice(index, 1);
    setLocations(newArr);
  }

  function addLocation() {
    const newArr = [...locations];
    newArr.push({
      _id: Math.floor(Math.random() * 10000),
      img: ImageWithLocationIcon,
      address: address,
      venueName: venueName,
      ...locationDetail,
    });
    setLocations(newArr);
    setAddress("");
    setVenueName("");
  }
  // Save And Finish Later
  function saveDataIntoRedux() {
    dispatch(setPersonalData("address", locations));
  }

  console.log({ getDataFromRedux });

  return (
    <div className={classes.address}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <Row className={`g-0 ${classes.row} `}>
        <Col md={12} className={classes.innerContainer}>
          <Col sm={12}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
                fontWeight: 400,
              }}
            >
              Where would you host your lesson?
            </h3>

            <p
              className={classes.oneOnOne}
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
            >
              1-on-1 lesson
            </p>
          </Col>
          {locations.length == 0 && (
            <>
              <Col sm={12}>
                <div className={classes.mapBox}>
                  <Map myCoords={coordinate} borderRadius={"20px"} />
                </div>
              </Col>
              <Col sm={12} className={`${[classes.mt32].join(" ")}`}>
                <Input
                  label={"Venue Name (Optional)"}
                  state={venueName}
                  setter={setVenueName}
                  placeholder={"Type here.."}
                />
              </Col>
              <Col sm={12} className={`${[classes.mt32].join(" ")}`}>
                <Maps
                  type={"places"}
                  label={"Address"}
                  setAddress={setAddress}
                  placeholder={"Type here.."}
                  setCoordinates={setCoordinate}
                  setPlaceDetail={setLocationDetail}
                />
              </Col>
            </>
          )}
          {/* Added Locations */}
          <Col sm={12} className={classes.mt52}>
            {locations?.map((item) => {
              return (
                <div className={classes.addedLocation}>
                  <div className={classes.left}>
                    <div className={classes.imgBox}>
                      <img src={item?.img} />
                    </div>
                    {/* Buttons */}
                    <div className={classes.editAndDeleteBtns}>
                      <Button
                        icon={TrashIconGray}
                        onClick={() => {
                          deleteLocation(item);
                          saveDataIntoRedux();
                        }}
                        primary={false}
                        size={"Small"}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          marginRight: "12px",
                        }}
                      />
                      <Button
                        icon={EditIconDarkGray}
                        primary={false}
                        size={"Small"}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        }}
                        onClick={() => {
                          setEditingData(item);
                          setIsEditing(true);
                        }}
                      />
                    </div>
                  </div>
                  <div className={classes.description}>
                    <span
                      style={{
                        ...Fonts.otherMedium,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    >
                      {item?.address}
                    </span>
                    <h6
                      style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
                    >
                      {item?.venueName}
                    </h6>
                    <p
                      style={{
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    >
                      {item?.city},{item?.state},{item?.country}
                    </p>
                  </div>
                </div>
              );
            })}
          </Col>

          {/* Add Location */}
          <Col sm={12} className={`${[classes.mt32].join(" ")}`}>
            <LinkButtonWithIcon
              leftIcon={AddIconBlue}
              text={"Add Location"}
              primary={true}
              disabled={
                (locations?.length == 0 && address == "" && true) || false
              }
              iconStyle={{
                marginRight: "10px",
              }}
              onClick={() => {
                locations?.length == 0
                  ? addLocation()
                  : setOpenAddLocation(true);
              }}
            />
          </Col>
        </Col>
        {/* End Of inner container */}
        <Col
          sm={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                width: "max-content",
                height: "56px",
              }}
              onClick={() => stepForwardAndBackward(2, 1)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "156px", height: "56px", margin: "0px" }}
              onClick={() => {
                saveDataIntoRedux();
                stepForwardAndBackward(2, 3);
              }}
            />
          </div>
        </Col>
      </Row>

      {openAddLocation && (
        <AddLocationModal
          setShow={setOpenAddLocation}
          show={openAddLocation}
          onAdd={addLocationForModal}
        />
      )}
      {isEditing && (
        <AddLocationModal
          setShow={setIsEditing}
          show={isEditing}
          onAdd={editLocation}
          data={editingData}
          isEditing
        />
      )}
    </div>
  );
}
